import { render } from "./payment_summary.vue?vue&type=template&id=60265612"
import script from "./payment_summary.vue?vue&type=script&lang=js"
export * from "./payment_summary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__